/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import './ProgressBarStyles.scss';
const BASE_CLASS = 'qmb-ui-progress-bar';
export function ProgressBar({ value, color, showLabel = true, className }) {
    const clampedValue = Math.max(0, Math.min(100, value));
    return (React.createElement("div", { className: classNames(BASE_CLASS, className) },
        showLabel && React.createElement("span", { className: `${BASE_CLASS}__label` },
            clampedValue,
            "%"),
        React.createElement("div", { className: `${BASE_CLASS}__track` },
            React.createElement("div", { className: `${BASE_CLASS}__fill`, style: Object.assign({ width: `${clampedValue}%` }, (color ? { backgroundColor: color } : {})) }))));
}
